function w(a) {
  var s;
  if (!a)
    return 10;
  const {
    defaultPageSize: f
  } = a;
  if (f !== void 0)
    return f;
  const e = (s = a.pageSizes) === null || s === void 0 ? void 0 : s[0];
  return typeof e == "number" ? e : (e == null ? void 0 : e.value) || 10;
}
function h(a, s, f, e) {
  let m = !1, y = !1, F = 1, o = s;
  if (s === 1)
    return {
      hasFastBackward: !1,
      hasFastForward: !1,
      fastForwardTo: o,
      fastBackwardTo: F,
      items: [{
        type: "page",
        label: 1,
        active: a === 1,
        mayBeFastBackward: !1,
        mayBeFastForward: !1
      }]
    };
  if (s === 2)
    return {
      hasFastBackward: !1,
      hasFastForward: !1,
      fastForwardTo: o,
      fastBackwardTo: F,
      items: [{
        type: "page",
        label: 1,
        active: a === 1,
        mayBeFastBackward: !1,
        mayBeFastForward: !1
      }, {
        type: "page",
        label: 2,
        active: a === 2,
        mayBeFastBackward: !0,
        mayBeFastForward: !1
      }]
    };
  const i = 1, t = s;
  let d = a, r = a;
  const c = (f - 5) / 2;
  r += Math.ceil(c), r = Math.min(Math.max(r, i + f - 3), t - 2), d -= Math.floor(c), d = Math.max(Math.min(d, t - f + 3), i + 2);
  let n = !1, p = !1;
  d > i + 2 && (n = !0), r < t - 2 && (p = !0);
  const l = [];
  l.push({
    type: "page",
    label: 1,
    active: a === 1,
    mayBeFastBackward: !1,
    mayBeFastForward: !1
  }), n ? (m = !0, F = d - 1, l.push({
    type: "fast-backward",
    active: !1,
    label: void 0,
    options: e ? u(i + 1, d - 1) : null
  })) : t >= i + 1 && l.push({
    type: "page",
    label: i + 1,
    mayBeFastBackward: !0,
    mayBeFastForward: !1,
    active: a === i + 1
  });
  for (let B = d; B <= r; ++B)
    l.push({
      type: "page",
      label: B,
      mayBeFastBackward: !1,
      mayBeFastForward: !1,
      active: a === B
    });
  return p ? (y = !0, o = r + 1, l.push({
    type: "fast-forward",
    active: !1,
    label: void 0,
    options: e ? u(r + 1, t - 1) : null
  })) : r === t - 2 && l[l.length - 1].label !== t - 1 && l.push({
    type: "page",
    mayBeFastForward: !0,
    mayBeFastBackward: !1,
    label: t - 1,
    active: a === t - 1
  }), l[l.length - 1].label !== t && l.push({
    type: "page",
    mayBeFastForward: !1,
    mayBeFastBackward: !1,
    label: t,
    active: a === t
  }), {
    hasFastBackward: m,
    hasFastForward: y,
    fastBackwardTo: F,
    fastForwardTo: o,
    items: l
  };
}
function u(a, s) {
  const f = [];
  for (let e = a; e <= s; ++e)
    f.push({
      label: `${e}`,
      value: e
    });
  return f;
}
export {
  h as createPageItemsInfo,
  w as getDefaultPageSize
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/pagination/src/utils.js
// module id = 926
// module chunks = 41